import React from 'react'

const DeliveryAreas = ({ deliveryAreas = [] }) => {
  // console.log('deliveryAreas', deliveryAreas)
  return (
    <div
      className="p-4 rounded shadow-sm w-100 mb-4"
      style={{ backgroundColor: "#f6f6fe", maxWidth: "300px" }}
    >
      <h5 className="fw-bold text-center mb-4">Top 5 Delivery Areas</h5>
      <ul className="list-unstyled m-0 p-0">
        {deliveryAreas.map((area, index) => (
          <li key={index} className="mb-2">
            {++index}. {area?._id}
          </li>
        ))}
      </ul>
    </div>
  )
}

export default DeliveryAreas